/*
 * @author Lemuel Raganas <lemuel.raganas@mediacorp.com.sg>
 **/

import Noty from "noty";

interface NotifierOption {
  text?: string;
  type?: string;
}

class MyUiNotification {
  constructor() {}

  notify(option: NotifierOption) {
    const type: string = option.type || "info";

    const noty = new Noty({
      text: option.text,
      // @ts-ignore
      type: type,
      theme: "sunset",
      layout: "bottomRight",
    }).show();
  }

  info(text: string) {
    this.notify({
      text: text,
      type: "info",
    });
  }

  warning(text: string) {
    this.notify({
      text: text,
      type: "warning",
    });
  }

  error(text: string) {
    this.notify({
      text: text,
      type: "error",
    });
  }
}

export const UiNotification = new MyUiNotification();
